// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rm-name-box[data-v-768a90f4] {\n  background-color: #e6eaea;\n  padding: 0.65rem 1.1rem;\n  border-radius: 15px;\n}\n.rm-name-box h6[data-v-768a90f4] {\n  font-size: 0.88rem;\n  font-weight: 500;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
